import { render, staticRenderFns } from "./CartProductCard.vue?vue&type=template&id=48fb4016&scoped=true&"
import script from "./CartProductCard.vue?vue&type=script&lang=js&"
export * from "./CartProductCard.vue?vue&type=script&lang=js&"
import style0 from "./CartProductCard.vue?vue&type=style&index=0&id=48fb4016&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fb4016",
  null
  
)

export default component.exports